/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { get, post } from "@insite/client-framework/Services/ApiService";

const InvoicePaymentAPIUrl = "api/custom/invoicePayment/getArDocuments";
const invoicePaymentOptionsUrl = "/api/custom/invoicepayment/GetPaymentOptions";
const invoicePaymentUrl = "/api/custom/invoicepayment/MakePayment";

export function getInvoicePaymentItems() {
    return get<any>(`${InvoicePaymentAPIUrl}`);
}

export function getInvoicePaymentOptions() {
    return get<any>(invoicePaymentOptionsUrl);
}

export function placeInvoicePayment(payload: any) {
    return post<any>(invoicePaymentUrl, payload).then(
        (response: any) => {

        }
    ).catch(error => {
        throw new Error(error?.errorMessage);
    })
}